<span class="d-flex align-items-center">

  <a class="show-link" href="javascript:void(0)" (mouseenter)="showValue = true" (mouseleave)="showValue = false"
    cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    Show {{ textDescription }}
  </a>

  <span>
    <button mat-icon-button class="sm-button" [ariaLabel]="'Copy ' + textDescription"
      (click)="copy(); $event.stopPropagation();" [title]="'Copy ' + textDescription">
      <mat-icon fontSet="material-symbols-outlined">content_copy</mat-icon>
    </button>
  </span>
</span>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="showValue"
  (detach)="showValue = false">
  <mat-card class="hash-card">
    <mat-card-header>
      <mat-card-title>{{ textDescription }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="hash-text">
      <div>
        <span>{{ value }}</span>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>